import { cx } from 'classix';
import { Entry } from 'contentful';
import { useState } from 'react';
import { Question } from 'repos/questions';

import Triangle from './svgs/Triangle';

type Props = {
  title: string;
  questions: Entry<Question>[] | undefined;
};

export default function FAQBlock({ title, questions }: Props) {
  const [openedQuestionKey, setOpenedQuestionKey] = useState<string>();

  const handleClickQuestion = (key: string) => {
    if (openedQuestionKey === key) {
      setOpenedQuestionKey(undefined);
    } else {
      setOpenedQuestionKey(key);
    }
  };

  return (
    <section className="py-24">
      <div className="mx-auto flex max-w-5xl flex-col items-center px-6">
        <h2 className="text-r-4xl font-bold">{title}</h2>
        <div className="mt-8 w-full">
          {(questions || []).map((question) => (
            <button
              key={question.sys.id}
              className="my-8 flex text-left"
              onClick={() => handleClickQuestion(question.sys.id)}
            >
              <div>
                <div
                  className={cx(
                    'mr-4 rounded-full border-[3px] border-primary p-2',
                    openedQuestionKey === question.sys.id && 'bg-primary'
                  )}
                >
                  <Triangle
                    width={12}
                    className={cx(
                      openedQuestionKey === question.sys.id &&
                        'rotate-180 text-white',
                      openedQuestionKey !== question.sys.id && 'text-secondary'
                    )}
                  />
                </div>
              </div>
              <div>
                <div className="flex items-center">
                  <div className="text-r-xl font-bold">
                    {question.fields.question}
                  </div>
                </div>
                <p
                  className={cx(
                    'mt-4',
                    openedQuestionKey !== question.sys.id && 'hidden' // Hidden instead of unrendered for improved SEO
                  )}
                >
                  {question.fields.answer}
                </p>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
